import { Outlet, useLocation } from "react-router-dom";
import { useLocale } from "@/context/LocaleContext";
import { AnnouncementBar } from "./AnnouncementBar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileNav } from "./MobileNav";
import { CartDrawer } from "@/components/CartDrawer";
import { StyleAdvisor } from "@/components/StyleAdvisor";

export function Layout() {
  const { t } = useLocale();
  const {pathname}=useLocation();
  const assistantPage=pathname.replace(/\/+$/,'').toLowerCase()==="/stil-danismani";
  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] rounded-full bg-shule-coffee text-shule-paper px-5 py-3">{t("Ana içeriğe geç")}</a>
      <AnnouncementBar />
      <Header compact={assistantPage}/>
      <main id="main-content" tabIndex={-1} className="flex-1"><Outlet /></main>
      <Footer />
      <MobileNav />
      <CartDrawer />
      {!assistantPage&&<StyleAdvisor />}
    </div>
  );
}
